import React from 'react';
import { Skeleton } from '@mui/material';
import css from './Skeletons.css';

const Skeletons = React.memo(() => (
    <div className={css.skeletons}>
        {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className={css.container}>
                <Skeleton variant="rectangular" className={css.skeleton} />
            </div>
        ))}
    </div>
));

export default Skeletons;

